import { useState } from 'react';

export const useAudit = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getAuditData = async () => {
        // setLoading(true);
        // setError(null);

        try {
            const response = await fetch('https://api.ipify.org?format=json');
            if (!response.ok) throw new Error('Error al obtener la IP');
            const { ip } = await response.json();

            const auditPayload = {
                ip,
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent,
                language: navigator.language,
                screenSize: `${window.screen.width}x${window.screen.height}`,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            };

            // setLoading(false);
            return auditPayload;

        } catch (err) {
            setError(err.message);
            setLoading(false);
            return null;
        }
    };

    return { getAuditData, loading, error };
};